import React, { useState } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import LazyImage from '../../../hocs/Lazy/LazyImage';
import { imageSizeTranslation } from '../../../utils/image';
import { deepMerge } from '../../../utils/object';
import s from './Dropbox.scss';

const Dropbox = ({ downloads, content }) => {
	if (!Object.keys(downloads).length > 0) return null;

	const [dropboxExpanded, toggleDropbox] = useState(false);

	const recursiveFolderNavigation = (object, pathParts) => {
		const currentPathPart = pathParts.shift();
		if (object?.[currentPathPart]?.children && pathParts.length > 0) return recursiveFolderNavigation(object[currentPathPart].children, pathParts);
		if (object?.[currentPathPart]) return object[currentPathPart];
		return [];
	};

	/* Extract relevant downloads */
	const currentDownloads = [];
	content.folder.forEach((folder) => {
		const folderParts = folder.split('/');
		currentDownloads.push(recursiveFolderNavigation(downloads, folderParts));
	});

	const mergedDownloads = currentDownloads.length > 0 ? currentDownloads.reduce((acc, collection) => deepMerge(acc, collection), {}) : {};
	const sortOrder = ['pressRelease', 'pressImages', '3dModels', '3dModels-BenchesDaybedsShelves', '3dModels-HighTables', '3dModels-Tables', 'productCertificatesandCompliance', 'productLiterature', 'careandWarranty'];

	const recursiveDownloadLinks = (section) => {
		if ((!section.files || section.files.length === 0) && (!section.children || Object.keys(section.children).length === 0)) return null;
		return (
			<div key={section.name} className={s.dropbox_item}>
				{ section.files && section.files.length > 0 && <h5 className={s.dropbox_item_title}>{ section.name }</h5> }
				<div className={[s.dropbox_item_files, content.showMedia && section.files && section.files.filter((file) => file.thumbnail).length > 0 ? s.dropbox_item_files__grid : null].join(' ')}>
					{
						section.files && section.files.map((file) => {
							if (content.showMedia && file.thumbnail) {
								return (
									<a key={file.link} className={[s.dropbox_item_file, s.dropbox_item_file__image].join(' ')} href={file.link} target="_blank" rel="noopener noreferrer">
										<LazyImage {...imageSizeTranslation('3', file.thumbnail)} />
									</a>
								);
							}
							if (content.showMedia && /\.mp4/.test(file.link)) {
								return (
									<a key={file.link} className={[s.dropbox_item_file, s.dropbox_item_file__image, s.dropbox_item_file__video].join(' ')} href={file.link} target="_blank" rel="noopener noreferrer">
										<video src={file.link} autoPlay={false} loop playsInline muted alt={file.name.replace(/(^emeco)?[_-]/ig, ' ').replace(/\..*$/, '').trim()} />
									</a>
								);
							}
							return (
								<a key={file.link} className={[s.dropbox_item_file, (/\.(rfa|dwg)$/.test(file.name) ? s.dropbox_item_file__3d : s.dropbox_item_file__pdf)].join(' ')} href={file.link.replace(/(\.pdf.*dl)=1/, '$1=0')} target="_blank" rel="noopener noreferrer">
									{ file.name.replace(/(^emeco)?[_-]/ig, ' ').replace(/\.[^.]*$/, '').trim() }
								</a>
							);
						})
					}
					{
						Object.keys(section.children).length > 0 && Object.keys(section.children).sort((a, b) => {
							const sortA = sortOrder.indexOf(a) === -1 ? 1e6 : sortOrder.indexOf(a);
							const sortB = sortOrder.indexOf(b) === -1 ? 1e6 : sortOrder.indexOf(b);
							if (sortA > sortB) return 1;
							if (sortA < sortB) return -1;
							return a.localeCompare(b);
						}).map((reccurringSection) => recursiveDownloadLinks(section.children[reccurringSection]))
					}
				</div>
			</div>
		);
	};

	const toggleDropboxHandler = (e) => {
		e.preventDefault();
		toggleDropbox((prevState) => !prevState);
	};

	return (
		<div className={[s.dropbox, dropboxExpanded ? s.dropbox__expanded : null].join(' ')}>
			<a className={s.dropbox_title} href="#toggle-downloads" onClick={toggleDropboxHandler}>
				<h4 className={s.dropbox_title_text}>{ mergedDownloads.name }</h4>
			</a>
			<div className={s.dropbox_items}>
				{
					recursiveDownloadLinks(mergedDownloads)
				}
			</div>
		</div>
	);
};

const mapState = ({ environment }, props) => ({
	downloads: environment.downloads,
	...props,
});

export default hot(module)(connect(mapState)(Dropbox));
